'use strict';

import { CoreRepository } from '../CoreRepository';
import { AgencyDownline } from '../../Entities/Agency/AgencyDownline';
import { AgencyDownlineCollection } from '../../Collections/Agency/AgencyDownlineCollection';

export class AgencyDownlineRepository extends CoreRepository {
  public getAgencyDownlines(userId: number, agencyId: number, options: object = {}) {
    return this.webAPI.getAgencyDownlines(userId, agencyId, options).then((response) => {
      const collection = new AgencyDownlineCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new AgencyDownline();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getAgencyLoasAndPrincipal(userId: number, agencyId: number, options: object = {}) {
    return this.webAPI.getAgencyLoasAndPrincipal(userId, agencyId, options).then((response) => {
      const collection = new AgencyDownlineCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new AgencyDownline();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getAgencyLoas(userId: number, agencyId: number, options: object = {}) {
    return this.webAPI.getAgencyLoas(userId, agencyId, options).then((response) => {
      const collection = new AgencyDownlineCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new AgencyDownline();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }
  /*
  public addAgencyDownline(agencyId, payload: any[]) {
    return this.webAPI.addAgencyDownline(agencyId, payload)
      .then(response => {
        return response;
      });
  }


  public updateAgencyDownline(agencyId: number, urlId: number, payload: any[]) {
    return this.webAPI.updateAgencyDownline(agencyId, urlId, payload)
      .then(response => {
        return response;
      });

  }

  public deleteAgencyDownline(agencyId: number, urlId: number) {
    return this.webAPI.deleteAgencyDownline(agencyId, urlId)
      .then(response => {
        return response;
      });

  }
*/
}
